// helpers/Share.js

/**
 * Save a shared post on the backend
 */
export async function saveSharedPost(postId) {
  if (!postId) return;

  try {
    await fetch("/api/share/save", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ postId }),
    });
  } catch (err) {
    
  }
}

/**
 * Get latest shared postId from backend
 */
export async function getLatestSharedPost() {
  try {
    const res = await fetch("/api/share/latest");
    const data = await res.json();

    return data?.postId || null;
  } catch (err) {
 
    return null;
  }
}

/**
 * Load shared post and navigate to Post page
 */
export async function openSharedPost({
  navigate,
  fetchPostWithComments,
  setCommentsByPost,
}) {
  try {
    const postId = await getLatestSharedPost();

    if (!postId) return;

    const { post, comments } = await fetchPostWithComments(postId);

    navigate("/", {
      replace: true,
      state: {
        view: "post",
        post,
      },
    });

    setCommentsByPost((prev) => ({
      ...prev,
      [postId]: comments,
    }));

  } catch (err) {
  
  }
}